import { Record } from "immutable";
import { OrganizationEventSummary } from "models/interfaces/contracts/organization-event-summary";
// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: OrganizationEventSummary = {
    year: undefined,
    totalEvents: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class OrganizationEventSummaryRecord extends Record(defaultValues) implements OrganizationEventSummary {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<OrganizationEventSummary>) {
        params = params ?? Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    /**
     * Given a set of values for OrganizationEventSummary properties, create a new OrganizationEventSummaryRecord object from this
     * instance, overwriting the properties in the values parameter with values provided.
     *
     * @param {Partial<OrganizationEventSummary>} values The values to overwrite on this instance.
     * @returns A OrganizationEventSummaryRecord with values from this instance and the values parameter.
     */
    public with(values: Partial<OrganizationEventSummary>): OrganizationEventSummaryRecord {
        return new OrganizationEventSummaryRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { OrganizationEventSummaryRecord };

// #endregion Exports
